// PWA: register the service worker, and offer "add to home screen" — a real
// install prompt on Android, a dismissible how-to hint on iOS. Shown once, the
// dismissal is remembered, and it stays re-openable from Settings.

const DISMISS_KEY = 'lk_install_dismissed';
const SHARE_SVG = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" style="vertical-align:-2px"><path d="M12 3l-3 3M12 3l3 3M12 3v12M6 11H5v9h14v-9h-1" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

function isStandalone(): boolean {
  return window.matchMedia('(display-mode: standalone)').matches || (navigator as any).standalone === true;
}
function isIOS(): boolean {
  return /iphone|ipad|ipod/i.test(navigator.userAgent) && !(window as any).MSStream;
}

export function setupPWA() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => navigator.serviceWorker.register('/sw.js').catch(() => {}));
  }

  const bannerMaybe = document.getElementById('install-banner');
  if (!bannerMaybe) return;
  const banner: HTMLElement = bannerMaybe;
  let deferredPrompt: any = null;

  const dismiss = () => { try { localStorage.setItem(DISMISS_KEY, '1'); } catch {} banner.hidden = true; };
  const dismissed = () => { try { return localStorage.getItem(DISMISS_KEY) === '1'; } catch { return false; } };

  function renderAndroid() {
    banner.innerHTML = `
      <div class="row">
        <img class="install-icon" src="/icons/icon-192.png" alt="" />
        <div class="grow"><div class="ttl">Install Loomkeep</div><div class="sub">Full-screen and private, like a native app.</div></div>
        <button class="install-x" aria-label="Dismiss">&times;</button>
      </div>
      <div class="install-actions"><button class="btn ghost sm" id="lk-later" style="flex:1">Not now</button><button class="btn primary sm" id="lk-install" style="flex:1.4">Install</button></div>`;
    banner.querySelector('.install-x')!.addEventListener('click', dismiss);
    banner.querySelector('#lk-later')!.addEventListener('click', dismiss);
    banner.querySelector('#lk-install')!.addEventListener('click', async () => {
      if (!deferredPrompt) return dismiss();
      deferredPrompt.prompt();
      await deferredPrompt.userChoice.catch(() => {});
      deferredPrompt = null; dismiss();
    });
    banner.hidden = false;
  }

  function renderIOS() {
    banner.innerHTML = `
      <div class="row">
        <img class="install-icon" src="/icons/icon-192.png" alt="" />
        <div class="grow"><div class="ttl">Add Loomkeep to your Home Screen</div>
          <div class="sub">Open it like an app — full-screen and private. Tap ${SHARE_SVG} below, then <strong>Add to Home Screen</strong>.</div></div>
        <button class="install-x" aria-label="Dismiss">&times;</button>
      </div>
      <div class="install-actions" style="justify-content:space-between">
        <button class="btn quiet sm" id="lk-never">Don’t show again</button>
        <span class="faint" style="font-size:11.5px;align-self:center">Always in Settings</span>
      </div>`;
    banner.querySelector('.install-x')!.addEventListener('click', dismiss);
    banner.querySelector('#lk-never')!.addEventListener('click', dismiss);
    banner.hidden = false;
  }

  // Re-openable from Settings (clears the dismissal and shows the right variant).
  (window as any).lkShowInstall = () => {
    if (isStandalone()) { alert('Loomkeep is already installed on your Home Screen.'); return; }
    try { localStorage.removeItem(DISMISS_KEY); } catch {}
    if (deferredPrompt) renderAndroid();
    else if (isIOS()) renderIOS();
    else alert('To install: open your browser menu and choose “Install app” or “Add to Home Screen.”');
  };

  if (isStandalone()) return;

  // Android: the browser fires this when the app is installable.
  window.addEventListener('beforeinstallprompt', (e: Event) => {
    e.preventDefault();
    deferredPrompt = e;
    if (!dismissed()) renderAndroid();
  });

  // iOS has no prompt event — show the hint once.
  if (isIOS() && !dismissed()) renderIOS();
}
